import { OFCVariant, Rank, RowPosition, Suit } from './enums';

/**
 * Number of cards each row can hold
 */
export const ROW_CAPACITY: Record<RowPosition, number> = {
  [RowPosition.FRONT]: 3,
  [RowPosition.MIDDLE]: 5,
  [RowPosition.BACK]: 5,
};

/**
 * Standard suits (excluding wild)
 */
export const STANDARD_SUITS: readonly Suit[] = [Suit.CLUB, Suit.DIAMOND, Suit.HEART, Suit.SPADE];

/**
 * Standard rank ordering (2 low, A high)
 */
export const RANK_ORDER_STANDARD: readonly Rank[] = [
  Rank.DEUCE,
  Rank.TREY,
  Rank.FOUR,
  Rank.FIVE,
  Rank.SIX,
  Rank.SEVEN,
  Rank.EIGHT,
  Rank.NINE,
  Rank.TEN,
  Rank.JACK,
  Rank.QUEEN,
  Rank.KING,
  Rank.ACE,
];

/**
 * Deuce-to-seven uses the same ordering - Ace is always high (worst for lowball).
 * Kept as alias for semantic clarity when working with 2-7 variant code.
 */
export const RANK_ORDER_DEUCE_TO_SEVEN = RANK_ORDER_STANDARD;

/**
 * Short codes for OFC variants (used in notation/PHH)
 */
export const OFC_VARIANT_CODES: Record<OFCVariant, string> = {
  [OFCVariant.OpenFaceChineseStandard]: 'OFC',
  [OFCVariant.OpenFaceChinesePineapple]: 'OFC-P',
  [OFCVariant.OpenFaceChinesePineappleFantasy]: 'OFC-PF',
  [OFCVariant.OpenFaceChineseDeuceToSeven]: 'OFC-27',
  [OFCVariant.OpenFaceChinesePineappleDeuceToSeven]: 'OFC-P27',
  [OFCVariant.OpenFaceChineseJoker]: 'OFC-J',
  [OFCVariant.OpenFaceChinesePineappleJoker]: 'OFC-PJ',
};
